<!-- <div fxLayout="row" fxLayoutAlign="space-around center"> -->
<div class="spinner-overlay" *ngIf="cargandoDatos">
  <div class="spinner-center">
    <mat-spinner
      *ngIf="cargandoDatos"
      diameter="80"
      color="primary"
    ></mat-spinner>
    <label class="input-label" *ngIf="cargandoDatos"
      >&nbsp; Cargando datos...</label
    >
  </div>
</div>

<app-header
  sub_titulo="Bandeja de asistentes"
  [todas_opciones]="true"
></app-header>

<!-- Panel izquierda -->
<mat-card style="background-color: #f8f8ff; width: 100%; height: auto">
  <div id="menus" style="min-height: 95vh; height: auto">
    <div
      class="card-body-content"
      style="width: 99%; min-height: 90%; max-height: 99%; height: 90%"
    >
      <br />
      <mat-card style="height: 99%">
        <div class="card-body-content" style="display: flex; height: auto">
          <div style="background-color: #f8f8ff; width: 100%; height: auto">
            <mat-card class="card-principal" appearance="outlined">
              <div style="width: 100%" class="container">
                <div id="flex-start" class="botonera">
                  <button
                    *ngIf="menuSeleccionado?.tipo == AsistenteTipo.Menu"
                    mat-raised-button
                    [disabled]="!habilitarBotones"
                    [ngStyle]="
                      habilitarBotones
                        ? { 'background-color': '#3f51b5' }
                        : {
                            'background-color': 'rgba(0,0,0,.12)',
                            color: '#3a3737',
                            'font-size': '14px'
                          }
                    "
                    color="primary"
                    class="botonModificar botonMenu"
                    (click)="editarConfiguracionesMenu()"
                  >
                    Modificar contenido
                    <mat-icon>mode_edit</mat-icon>
                  </button>
                  <button
                    *ngIf="menuSeleccionado"
                    mat-raised-button
                    [disabled]="!habilitarBotones"
                    [ngStyle]="
                      habilitarBotones
                        ? { 'background-color': '#3f51b5' }
                        : {
                            'background-color': 'rgba(0,0,0,.12)',
                            color: '#3a3737',
                            'font-size': '14px'
                          }
                    "
                    color="primary"
                    class="botonModificar botonMenu"
                    (click)="editarDatosBasicosMenu()"
                    style="background-color: #3f51b5"
                  >
                    Modificar datos básicos
                    <mat-icon>mode_edit</mat-icon>
                  </button>
                  <button
                    *ngIf="menuSeleccionado"
                    mat-raised-button
                    [disabled]="!habilitarBotones"
                    [ngStyle]="
                      habilitarBotones
                        ? { 'background-color': '#3f51b5' }
                        : {
                            'background-color': 'rgba(0,0,0,.12)',
                            color: '#3a3737',
                            'font-size': '14px'
                          }
                    "
                    color="primary"
                    class="botonModificar botonMenu"
                    (click)="editarValidacionesMenu()"
                    style="background-color: #3f51b5"
                  >
                    Modificar validaciones
                    <mat-icon>mode_edit</mat-icon>
                  </button>
                  <button
                    *ngIf="menuSeleccionado?.tipo == AsistenteTipo.Menu"
                    mat-raised-button
                    [disabled]="!habilitarBotones"
                    [ngStyle]="
                      habilitarBotones
                        ? { 'background-color': '#3f51b5' }
                        : {
                            'background-color': 'rgba(0,0,0,.12)',
                            color: '#3a3737',
                            'font-size': '14px'
                          }
                    "
                    color="primary"
                    class="botonModificar botonMenu"
                    (click)="editarDestinatariosMenu()"
                    style="background-color: #3f51b5"
                  >
                    Modificar destinatarios
                    <mat-icon>mode_edit</mat-icon>
                  </button>
                  <button
                    *ngIf="menuSeleccionado && puedeCrearOEliminarMenu"
                    mat-raised-button
                    [disabled]="!habilitarBotonEliminar"
                    [ngStyle]="
                      habilitarBotonEliminar
                        ? { 'background-color': '#f44336' }
                        : {
                            'background-color': 'rgba(0,0,0,.12)',
                            color: '#3a3737',
                            'font-size': '14px'
                          }
                    "
                    color="warn"
                    (click)="seleccionarParaEliminar()"
                    class="botonMenu"
                  >
                    Borrar asistente
                    <mat-icon>delete</mat-icon>
                  </button>
                  <button
                    *ngIf="menuSeleccionado?.tipo == AsistenteTipo.Menu"
                    mat-raised-button
                    [disabled]="!habilitarBotones"
                    [ngStyle]="
                      habilitarBotones
                        ? { 'background-color': '#3f51b5' }
                        : {
                            'background-color': 'rgba(0,0,0,.12)',
                            color: 'black',
                            'font-size': '14px'
                          }
                    "
                    color="primary"
                    (click)="exportarMenu()"
                    class="botonMenu"
                  >
                    Exportar Menú
                    <mat-icon>file_download</mat-icon>
                  </button>
                  <button
                    *ngIf="menuSeleccionado?.tipo == AsistenteTipo.Menu"
                    mat-raised-button
                    [disabled]="!habilitarBotones"
                    [ngStyle]="
                      habilitarBotones
                        ? { 'background-color': '#3f51b5' }
                        : {
                            'background-color': 'rgba(0,0,0,.12)',
                            color: 'black',
                            'font-size': '14px'
                          }
                    "
                    style="background-color: #3f51b5"
                    color="primary"
                    (click)="cargarArchivo()"
                    class="botonMenu"
                  >
                    Importar Menú
                    <mat-icon>file_upload</mat-icon>
                  </button>
                </div>
                <div id="flex-end">
                  <button
                    mat-fab
                    class="btn-refresh"
                    title="Recargar asistentes"
                    (click)="recargarAsistentes()"
                  >
                    <mat-icon>refresh</mat-icon>
                  </button>

                  <mat-form-field class="form-filter-area" appearance="fill">
                    <mat-label>Filtrar por área funcional</mat-label>
                    <mat-select
                      (selectionChange)="aplicarFiltros()"
                      [(ngModel)]="areasFuncionalesGAFUSeleccionada"
                      name="area"
                    >
                      <mat-option
                        *ngFor="let area of areasFuncionalesGAFU"
                        [value]="area"
                      >
                        <span *ngIf="area.areaFuncional == '*'"
                          >Sin Restricción</span
                        >
                        <span *ngIf="area.areaFuncional != '*'">{{
                          area.areaFuncional
                        }}</span>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="form-filter-area" appearance="fill">
                    <mat-label>Filtrar por tipo</mat-label>
                    <mat-select
                      (selectionChange)="aplicarFiltros()"
                      [(ngModel)]="tipoAsistenteFiltro"
                      name="area"
                    >
                      <mat-option value="">Todos</mat-option>
                      <mat-option
                        *ngFor="let tipoAsistente of tiposAsistentes"
                        [value]="tipoAsistente"
                      >
                        <span>{{ tipoAsistente }}</span>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="form-filter-codigo" appearance="fill">
                      <mat-label>Filtrar por código</mat-label>
                      <input matInput (keyup)="aplicarFiltros()" [(ngModel)]="filtroCodigo">
                  </mat-form-field>
                  <mat-form-field class="form-filter-nombre" appearance="fill">
                      <mat-label>Filtrar por nombre</mat-label>
                      <input matInput (keyup)="aplicarFiltros()" [(ngModel)]="filtroNombre">
                  </mat-form-field>
                </div>
              </div>
              <div class="contenedor_tabla">
                <mat-table
                  #table
                  [dataSource]="dataSource"
                  matSort
                  class="mat-elevation-z8"
                >
                  <ng-container matColumnDef="id">
                    <mat-header-cell *matHeaderCellDef class="column-width-55">
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      class="column-width-55"
                      [ngStyle]="
                        element.habilitado
                          ? { 'background-color': 'rgb(240 243 243)' }
                          : { 'background-color': 'rgba(0,0,0,.12)' }
                      "
                    >
                      <mat-radio-button
                        class="radio-class"
                        (change)="seleccionarMenu(element)"
                      >
                      </mat-radio-button>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="codigoAsistente">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="textoCentradoTabla  column-width-100"
                    >
                      Código
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      [ngStyle]="
                        element.habilitado
                          ? { 'background-color': 'rgb(240 243 243)' }
                          : { 'background-color': 'rgba(0,0,0,.12)' }
                      "
                    >
                      {{ element.codigoAsistente }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="nombre">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="textoCentradoTabla">
                      Nombre
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      [ngStyle]="
                        element.habilitado
                          ? { 'background-color': 'rgb(240 243 243)' }
                          : { 'background-color': 'rgba(0,0,0,.12)' }
                      "
                    >
                      {{ element.nombre }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="tipo">
                    <mat-header-cell
                      *matHeaderCellDef
                      class="textoCentradoTabla column-width-90"
                      mat-sort-header
                    >
                      Tipo
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      class="textoCentradoTabla column-width-90"
                      [ngStyle]="
                        element.habilitado
                          ? { 'background-color': 'rgb(240 243 243)' }
                          : { 'background-color': 'rgba(0,0,0,.12)' }
                      "
                    >
                      {{ element.tipo }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="gafuAreaFuncional">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="textoCentradoTabla column-width-150"
                    >
                      Área Funcional
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      class="textoCentradoTabla column-width-150"
                      [ngStyle]="
                        element.habilitado
                          ? { 'background-color': 'rgb(240 243 243)' }
                          : { 'background-color': 'rgba(0,0,0,.12)' }
                      "
                    >
                      {{ element.gafuAreaFuncional }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="fechaActualizacion">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="textoCentradoTabla column-width-170"
                    >
                      Fecha Actualización
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      class="textoCentradoTabla column-width-170"
                      [ngStyle]="
                        element.habilitado
                          ? { 'background-color': 'rgb(240 243 243)' }
                          : { 'background-color': 'rgba(0,0,0,.12)' }
                      "
                    >
                      {{ element.fechaActualizacion }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="usuarioAutualizador">
                    <mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="textoCentradoTabla column-width-170"
                    >
                      Usuario
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      class="textoCentradoTabla column-width-170"
                      [ngStyle]="
                        element.habilitado
                          ? { 'background-color': 'rgb(240 243 243)' }
                          : { 'background-color': 'rgba(0,0,0,.12)' }
                      "
                    >
                      {{ element.usuarioAutualizador }}
                    </mat-cell>
                  </ng-container>

                  <mat-header-row
                    *matHeaderRowDef="displayedColumns"
                  ></mat-header-row>
                  <mat-row
                    *matRowDef="let row; columns: displayedColumns"
                  ></mat-row>
                </mat-table>
                <mat-paginator
                  [length]="100"
                  [pageSize]="25"
                  [pageSizeOptions]="[5, 10, 25, 100]"
                >
                </mat-paginator>
              </div>
            </mat-card>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</mat-card>
<!-- </div> -->
